import { PageSpinner } from "@components/layouts/content/PageSpinner";
import PageWithDynamicZoneLayout from "@components/layouts/content/PageWithDynamicZoneLayout";
import { createPageElement } from "@modules/content/creators/createPageElement";
import { usePageData } from "@modules/content/hooks/usePageData";
import { ContentPage } from "@modules/content/types";
import { useIsLoadingVisibile } from "@utils/hooks/useIsLoadingVisible";

export const Ramadan = createPageElement(({ pageId, context }, ref) => {
  const { pageData, refresh, isLoading } = usePageData(
    {
      pageId: pageId ?? "",
      context,
    },
    ref
  );

  if (!pageData || pageData.id !== pageId) {
    return <RamadanPageLoading isLoading={isLoading} />;
  }

  return (
    <PageWithDynamicZoneLayout
      items={pageData?.dynamicZone ?? []}
      onRefresh={refresh}
      extraProps={{
        titleClassName: "text-ramadan-primary dark:text-dark-ramadan-primary",
      }}
    >
      <RamadanBackground />
      <h1 className="mt-[20px] px-10 pb-[85px] text-right text-[44px] font-bold text-ramadan-primary dark:text-dark-ramadan-primary">
        {pageData?.parameters?.title?.value}
      </h1>
    </PageWithDynamicZoneLayout>
  );
});

const RamadanPageLoading = ({ isLoading }: { isLoading: boolean }) => {
  const isLoadingVisible = useIsLoadingVisibile(isLoading);

  return isLoadingVisible ? <PageSpinner /> : null;
};

export const RamadanBackground = () => {
  return (
    <>
      <div className="absolute left-0 top-0 z-10 h-[55px] overflow-hidden">
        <img
          src="/assets/images/ramadan-4.svg"
          alt="ramadan"
          className="h-[55px] w-[250px]"
        />
      </div>
      <div className="absolute left-[8px] top-[40px] z-10 h-[250px] w-[35px] overflow-hidden">
        <img
          src="/assets/images/ramadan-3.svg"
          alt="ramadan"
          className="stars h-[270px] w-[30px]"
        />
      </div>
      <div className="absolute left-[48px] top-[34px] z-10 h-[145px] w-[65px]">
        <img
          src="/assets/images/ramadan-2.svg"
          alt="ramadan"
          className="moon h-[145px] w-[65px]"
        />
      </div>
      <div className="absolute left-[117px] top-[23px] z-10 h-[210px] w-[50px] overflow-hidden">
        <img
          src="/assets/images/ramadan-1.svg"
          alt="ramadan"
          className="lantern h-[230px] w-[50px]"
        />
      </div>
    </>
  );
};

export const RamadanPage: ContentPage = {
  identifier: "PG:RAMADAN",
  page: Ramadan,
};
